import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { ThemeProvider } from './contexts/ThemeContext';
import { MainLayout } from './components/layout/MainLayout';
import { DashboardLayout } from './components/layout/DashboardLayout';

// Public pages
import HomePage from './pages/HomePage';
import HowItWorksPage from './pages/HowItWorksPage';
import ToolPage from './pages/ToolPage';
import PricingPage from './pages/PricingPage';
import ProjectsPage from './pages/ProjectsPage';
import ContactPage from './pages/ContactPage';
import LoginPage from './pages/LoginPage';
import { BlogListPage } from './pages/blog/BlogListPage';
import { BlogPostPage } from './pages/blog/BlogPostPage';

// Dashboard pages
import {
  DashboardOverview,
  ProjectsListPage,
  ProjectDetailPage,
  InvoicesPage,
  InquiriesPage,
  ClientsPage,
  SettingsPage,
} from './pages/dashboard';

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            {/* Public routes */}
            <Route element={<MainLayout />}>
              <Route path="/" element={<HomePage />} />
              <Route path="/how-it-works" element={<HowItWorksPage />} />
              <Route path="/tool" element={<ToolPage />} />
              <Route path="/pricing" element={<PricingPage />} />
              <Route path="/projects" element={<ProjectsPage />} />
              <Route path="/contact" element={<ContactPage />} />
              <Route path="/newsletter" element={<BlogListPage />} />
              {/* Legacy routes - redirect to new paths */}
              <Route path="/substack" element={<BlogListPage />} />
              <Route path="/blog" element={<BlogPostPage />} />
              <Route path="/blog/:slug" element={<BlogPostPage />} />
            </Route>

            {/* Auth routes */}
            <Route path="/login" element={<LoginPage />} />

            {/* Dashboard routes (protected) */}
            <Route path="/dashboard" element={<DashboardLayout />}>
              <Route index element={<DashboardOverview />} />
              <Route path="projects" element={<ProjectsListPage />} />
              <Route path="projects/:id" element={<ProjectDetailPage />} />
              <Route path="invoices" element={<InvoicesPage />} />
              <Route path="notes" element={<DashboardOverview />} />
              <Route path="settings" element={<SettingsPage />} />
              {/* Admin-only routes */}
              <Route path="clients" element={<ClientsPage />} />
              <Route path="inquiries" element={<InquiriesPage />} />
            </Route>

            {/* Catch all */}
            <Route path="*" element={<HomePage />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
